import Flickity from '../flickity.pkgd.min.js';

export const Slider = {
    init() {
        var sliderFindApartmentsFour = document.querySelector(
            '.thumbnail-component-slider'
        );
        var flkty = new Flickity(sliderFindApartmentsFour, {
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            cellSelector: '.thumbnail-item',
            groupCells: true,
        });

        // Function to set the tabindex for interactive elements within a given parent element
        function setTabindexOnChildren(element, value) {
            // Find interactive elements (a, button, input, textarea, select, .price-val, .ari-rating)
            // and set their tabindex attribute to the given value
            $(element)
                .find(
                    // 'div',
                    'a, button, h3,img, input, textarea, select'
                )
                // .not('.thumb-nail-slider')
                .attr('tabindex', value);
        }

        function updateTabIndex() {
            // Loop through each community card in the carousel and set tabindex to -1 (disable focus)
            $(sliderFindApartmentsFour)
                .find('.thumbnail-item')
                .each(function () {
                    // $(this).attr('tabindex', '-1'); // Disable focus on all cards
                    // setTimeout(() => {
                    setTabindexOnChildren(this, '-1'); // Disable focus on child elements
                    // }, 2000);
                });

            // For the selected community card, set tabindex to 0 (enable focus)
            $(sliderFindApartmentsFour)
                .find('.thumbnail-item.is-selected')
                .each(function () {
                    // $(this).attr('tabindex', '0'); // Enable focus on the selected card
                    // setTimeout(() => {
                    setTabindexOnChildren(this, '0'); // Enable focus on child elements of the selected card
                    // }, 2500);
                });
        }

        // Event listener for when an item is selected in the Flickity carousel
        flkty.on('select', function () {
            updateTabIndex();
            // setTimeout(() => {
            // Focus on the first selected community card
            var firstSelected = $(sliderFindApartmentsFour)
                .find('.thumbnail-item.is-selected')
                .first();
            // firstSelected.focus(); // Set focus to the first selected card

            var ctaLink = firstSelected.find('.thumbnail-image img'); // Find the anchor tag inside .thumbnail-desc__cta
            // if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            if (window.innerWidth > 1024) {
                ctaLink.focus();
            }

            // }, 1500);
        });

        updateTabIndex();
    },
    // Other methods or properties
};
